import { HttpClient } from "helpers";
import { BaseResponseType, DataGridRequest, PagedResponseType } from "services/shared-models/sharedTypes";
import {
  CreateFinancialStatementRequest,
  FinancialStatementItemResult,
  FinancialStatementLocalResult,
  UpdateFinancialStatementRequest,
} from "./Models/FinancialStatementTypes";
import {AxiosResponse} from "axios";

export const FinancialStatementService = {
  createFinancialStatement: async (request: CreateFinancialStatementRequest) => {
    return await HttpClient.post<BaseResponseType<FinancialStatementItemResult>>(
      `/api/FinancialStatement/CreateFinancialStatement`,
      request,
    );
  },
  updateFinancialStatement: async (id: number, request: UpdateFinancialStatementRequest) => {
    return await HttpClient.put<BaseResponseType<FinancialStatementItemResult>>(
      `/api/FinancialStatement/UpdateFinancialStatement/${id}`,
      request,
    );
  },
  getFinancialStatementById: async (id: number) => {
    return await HttpClient.get<BaseResponseType<FinancialStatementItemResult>>(
      `/api/FinancialStatement/GetFinancialStatementById/${id}`,
    );
  },
  getAllFinancialStatements: async (request: DataGridRequest) => {
    return await HttpClient.post<PagedResponseType<FinancialStatementLocalResult>>(
      `/api/FinancialStatement/GetAllFinancialStatements`,
      request,
    );
  },
  deleteFinancialStatement: async (id: number) => {
    return await HttpClient.delete<BaseResponseType<boolean>>(
      `/api/FinancialStatement/DeleteFinancialStatement/${id}`,
    );
  },
  setAsPaid: async (id: number) => {
    return await HttpClient.put<BaseResponseType<FinancialStatementItemResult>>(
      `/api/FinancialStatement/SetAsPaid/${id}`,
    );
  },
  downloadFinancialStatement: async (id: number) => {

    const response = await HttpClient.get<AxiosResponse<Blob>>(`/api/FinancialStatement/DownloadFinancialStatement/${id}`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `FinancialStatement_${id}.pdf`; // Specify the file name with the appropriate extension
    document.body.appendChild(link);
    link.click();
    // Cleanup
    link.remove();
  },
};
